// Helpful? under the platform agent's finished answers and cards (D10). Wording from the Amigo design's copy sheet
// (Helpful?).
export default {
  question: '¿Te ha sido útil?',
  helpful: 'Útil',
  not_helpful: 'No útil',
  thanks: 'Gracias, anotado.',
};
